import script from "./JavaScriptApi.vue?vue&type=script&setup=true&lang=js"
export * from "./JavaScriptApi.vue?vue&type=script&setup=true&lang=js"

import "./JavaScriptApi.vue?vue&type=style&index=0&id=0d1f0a74&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d1f0a74"]])

export default __exports__